import { HomeViewType } from '@/core/presenter/viewModel/viewTypes';
import DoubleSProperty from './DoubleSProperty';
import TrxProperty from './TrxProperty';
import * as ViewModel from '@/core/presenter/viewModel';

interface IProps {
  trxAsset?: ViewModel.IAsset;
  tokenAsset?: ViewModel.IAsset;
  trxBalance: string;
  tokenBalance: string;
  trxKrw: string;
  tokenKrw: string;
  trxPrice: number;
  tokenPrice: number;
  onClickViewType: (viewType: HomeViewType) => void;
}

const PropertyArea = ({
  trxAsset,
  tokenAsset,
  trxBalance,
  tokenBalance,
  trxKrw,
  tokenKrw,
  trxPrice,
  tokenPrice,
  onClickViewType,
}: IProps): JSX.Element => {
  return (
    <div className="property-area">
      <ul className="portfolio">
        <DoubleSProperty
          tokenAsset={tokenAsset}
          trxBalance={trxBalance}
          tokenBalance={tokenBalance}
          tokenKrw={tokenKrw}
          tokenPrice={tokenPrice}
          onClickViewType={onClickViewType}
        />
        <TrxProperty
          trxAsset={trxAsset}
          trxBalance={trxBalance}
          trxKrw={trxKrw}
          trxPrice={trxPrice}
          onClickViewType={onClickViewType}
        />
      </ul>
    </div>
  );
};

export default PropertyArea;
